<template>
    <section>
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="mx-auto">
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>Sales partner Login form </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-text-field
                                    label="ID"
                                    v-model="loginId"
                                    prepend-icon="mdi-account"
                                    type="text"
                                    :rules="loginIdRules"
                                    required
                                ></v-text-field>
 
                                <v-text-field
                                    label="Password"
                                    v-model="password"
                                    prepend-icon="mdi-key-variant"
                                    type="password"
                                    :rules="passwordRules"
                                    required
                                    @keyup.enter="doLogin"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <div class="flex-grow-1"></div>
                            <v-btn color="primary" :disabled="!valid" @click="doLogin">Login</v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-snackbar v-model="snackbar" bottom>
                        {{error_message}}
                    </v-snackbar>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
        valid: true,
        loginId: "",
        snackbar:false,
        loginIdRules: [
            v => !!v || "ID is required",
            v => (v && v.length >= 2) || "ID is required"
        ],
        password: "",
        passwordRules: [
            v => !!v || "Password is required",
            v => (v && v.length >= 6) || "Password must be larger than 6 characters"
        ],
        error_message:""
    }),
    methods: {
      reset() {
            this.$refs.form.reset();
        },
      doLogin() {
       this.$session.start();
       this.$axios
        .post("ares/json/biz/misc/login.p", {
            loginId: this.loginId,
            password: this.password,
            clientSessionId: this.$session.id()
        })
        .then(response => {
          if (response.data.token !== "LoginError") {
                    this.$session.set("ARES", response.data.token);
                    /* this.$router.push("/navBar"); */
                    this.$router.push("/homepage");
          }  else {

            this.$store.dispatch('setSnackbar', {
                  showing: true,                     
                  text: "Login incorrect",      
                  color: "warning"     
             });       
              this.$session.destroy();
          } 
        })
      }
    }
  }
</script>
